document.addEventListener('DOMContentLoaded', () => {

  // ─── Nav overlap → header--center (Prestige `_verifyNavigationOverlap`) ──
  const headerEl = document.querySelector('.header');
  const headerInner = document.querySelector('.header__inner');
  const navEl = document.querySelector('.header__navigation');
  const DESKTOP_MQ = 990;
  const MENU_LOGO_GAP = 28;

  function updateHeaderHeight() {
    if (!headerEl) return;
    document.documentElement.style.setProperty(
      '--header-height',
      headerEl.clientHeight + 'px'
    );
  }

  function verifyNavigationOverlap() {
    if (!headerEl || !navEl || !headerInner) return;

    if (window.innerWidth < DESKTOP_MQ) {
      headerEl.classList.remove('header--center');
      headerEl.classList.add('header--initialized');
      updateHeaderHeight();
      return;
    }

    // Theme setting already uses bottom row — do not auto-switch
    if (headerEl.classList.contains('header--menu-row-bottom')) {
      headerEl.classList.remove('header--center');
      headerEl.classList.add('header--initialized');
      updateHeaderHeight();
      return;
    }

    // Measure in one-row mode, then stack only if menu actually hits the logo.
    headerEl.classList.remove('header--center');

    const menuList = navEl.querySelector('.header__menu-list');
    const logoEl = headerEl.querySelector('.header__logo-container');
    if (!menuList || !logoEl) {
      headerEl.classList.add('header--initialized');
      updateHeaderHeight();
      return;
    }

    void headerInner.offsetWidth;

    const lastItem = menuList.querySelector('.header__menu-item:last-child');
    const menuRight = (lastItem || menuList).getBoundingClientRect().right;
    const logoLeft = logoEl.getBoundingClientRect().left;
    const isOverlapping = menuRight + MENU_LOGO_GAP > logoLeft;

    if (isOverlapping) {
      headerEl.classList.add('header--center');
    }

    headerEl.classList.add('header--initialized');
    updateHeaderHeight();
  }

  verifyNavigationOverlap();

  let resizeRaf = null;
  const scheduleVerify = () => {
    if (resizeRaf) cancelAnimationFrame(resizeRaf);
    resizeRaf = requestAnimationFrame(verifyNavigationOverlap);
  };

  window.addEventListener('resize', scheduleVerify);
  if (headerInner && typeof ResizeObserver !== 'undefined') {
    new ResizeObserver(scheduleVerify).observe(headerInner);
  }

  // Prestige: --window-height is set once in <head>, then only when viewport WIDTH changes
  // (not on mobile URL-bar show/hide, which only changes innerHeight).
  let windowWidth = window.innerWidth;
  window.addEventListener('resize', function () {
    if (window.innerWidth === windowWidth) return;
    windowWidth = window.innerWidth;
    document.documentElement.style.setProperty('--window-height', window.innerHeight + 'px');
  });

  const logoImg = headerEl && headerEl.querySelector('.header__logo');
  if (logoImg && !logoImg.complete) {
    logoImg.addEventListener('load', scheduleVerify, { once: true });
  }

  // ─── Search Drawer ────────────────────────────────────────────────────────
  const searchTrigger = document.querySelector('[data-search-trigger]');
  const searchClose   = document.querySelector('[data-search-close]');
  const searchDrawer  = document.querySelector('[data-search-drawer]');
  const searchInput   = document.querySelector('[data-search-input]');
  const searchResults = document.querySelector('[data-search-results]');
  const searchInnerEl = searchResults
    ? searchResults.querySelector('.header__search-results-inner')
    : null;
  const pageOverlay = document.querySelector('[data-page-overlay]');
  const headerSection = document.getElementById('shopify-section-header');

  function focusSearchInput() {
    if (!searchInput) return;
    try {
      searchInput.focus({ preventScroll: true });
    } catch (e) {
      searchInput.focus();
    }
  }

  function openSearch() {
    if (!searchDrawer) return;
    searchDrawer.classList.add('header__search-drawer--open');
    searchDrawer.setAttribute('aria-hidden', 'false');
    // Prestige: overflow lock only — do NOT position:fixed the body (breaks sticky header)
    document.documentElement.classList.add('no-scroll');
    if (pageOverlay) {
      pageOverlay.classList.add('is-visible');
      pageOverlay.setAttribute('aria-hidden', 'false');
    }
    if (headerSection) headerSection.style.zIndex = '110';

    const onOpened = (event) => {
      if (event.target !== searchDrawer) return;
      if (event.propertyName && event.propertyName !== 'transform' && event.propertyName !== 'opacity') {
        return;
      }
      searchDrawer.removeEventListener('transitionend', onOpened);
      focusSearchInput();
    };
    searchDrawer.addEventListener('transitionend', onOpened);
    setTimeout(focusSearchInput, 280);
  }

  function closeSearch() {
    if (!searchDrawer) return;
    searchDrawer.classList.remove('header__search-drawer--open');
    searchDrawer.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('no-scroll');
    if (pageOverlay) {
      pageOverlay.classList.remove('is-visible');
      pageOverlay.setAttribute('aria-hidden', 'true');
    }
    if (headerSection) headerSection.style.zIndex = '';
    if (searchInput) searchInput.value = '';
    clearResults();
  }

  if (searchTrigger) {
    searchTrigger.addEventListener('click', (e) => {
      e.preventDefault();
      if (searchDrawer && searchDrawer.getAttribute('aria-hidden') === 'false') {
        closeSearch();
      } else {
        openSearch();
      }
    });
  }
  if (searchClose) {
    searchClose.addEventListener('click', closeSearch);
  }

  if (pageOverlay) {
    pageOverlay.addEventListener('click', () => {
      if (searchDrawer && searchDrawer.getAttribute('aria-hidden') === 'false') {
        closeSearch();
      }
    });
  }

  document.addEventListener('keydown', (e) => {
    if (
      e.key === 'Escape' &&
      searchDrawer &&
      searchDrawer.getAttribute('aria-hidden') === 'false'
    ) {
      closeSearch();
    }
  });

  // ─── Live Search (AJAX) — Prestige dual-query parity ─────────────────────
  let lastQuery = '';
  let debounceTimer = null;

  function getSearchMode() {
    return (window.theme && window.theme.searchMode) || 'product,article';
  }

  function getSearchUrl() {
    return (window.routes && window.routes.searchUrl) || '/search';
  }

  function clearResults() {
    if (!searchInnerEl) return;
    const mode = getSearchMode();
    if (mode === 'product') {
      searchInnerEl.innerHTML = '';
    } else {
      searchInnerEl.innerHTML =
        '<div class="ci-search-layout PageLayout PageLayout--breakLap">' +
        '<div class="ci-search-layout__primary PageLayout__Section"></div>' +
        '<div class="ci-search-layout__secondary PageLayout__Section PageLayout__Section--secondary"></div>' +
        '</div>';
    }
    if (searchResults) searchResults.setAttribute('aria-hidden', 'true');
  }

  function doSearch(query) {
    if (!searchInnerEl) return;

    if (!query || query.trim().length < 2) {
      clearResults();
      return;
    }

    const q = query.trim();
    lastQuery = q;
    const searchUrl = getSearchUrl();
    const mode = getSearchMode();
    const queryOptions = {
      credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
    };

    const queries = [
      fetch(
        `${searchUrl}?view=ajax&q=${encodeURIComponent(q)}*&type=product`,
        queryOptions
      ),
    ];

    if (mode !== 'product') {
      const secondaryType = mode.replace('product,', '');
      queries.push(
        fetch(
          `${searchUrl}?view=ajax&q=${encodeURIComponent(q)}*&type=${secondaryType}`,
          queryOptions
        )
      );
    }

    Promise.all(queries)
      .then((responses) => Promise.all(responses.map((r) => r.text())))
      .then((contents) => {
        if (q !== lastQuery) return;

        if (mode === 'product') {
          searchInnerEl.innerHTML =
            contents[0] ||
            `<p class="header__search-results-empty">No results found for "<em>${q}</em>"</p>`;
        } else {
          searchInnerEl.innerHTML =
            '<div class="ci-search-layout PageLayout PageLayout--breakLap">' +
            `<div class="ci-search-layout__primary PageLayout__Section">${contents[0] || ''}</div>` +
            `<div class="ci-search-layout__secondary PageLayout__Section PageLayout__Section--secondary">${contents[1] || ''}</div>` +
            '</div>';
        }

        if (searchResults) searchResults.setAttribute('aria-hidden', 'false');
      })
      .catch(() => {
        searchInnerEl.innerHTML = '';
      });
  }

  if (searchInput) {
    searchInput.addEventListener('input', (e) => {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => doSearch(e.target.value), 250);
    });

    // Prestige: block Enter submit when search includes non-product types
    searchInput.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' && getSearchMode() !== 'product') {
        e.preventDefault();
      }
    });
  }

  // ─── Mobile Navigation Drawer ─────────────────────────────────────────────
  const menuTrigger = document.querySelector('[data-mobile-menu-trigger]');
  const drawerClose = document.querySelector('[data-mobile-drawer-close]');
  const drawer      = document.querySelector('[data-mobile-drawer]');
  const overlay     = document.querySelector('[data-mobile-drawer-overlay]');

  function openMobileMenu() {
    if (!drawer) return;
    drawer.classList.add('header__mobile-drawer--open');
    drawer.setAttribute('aria-hidden', 'false');
    if (overlay) overlay.classList.add('header__mobile-drawer-overlay--open');
    document.documentElement.classList.add('no-scroll');
  }

  function closeMobileMenu() {
    if (!drawer) return;
    drawer.classList.remove('header__mobile-drawer--open');
    drawer.setAttribute('aria-hidden', 'true');
    if (overlay) overlay.classList.remove('header__mobile-drawer-overlay--open');
    document.documentElement.classList.remove('no-scroll');
  }

  if (menuTrigger) menuTrigger.addEventListener('click', openMobileMenu);
  if (drawerClose) drawerClose.addEventListener('click', closeMobileMenu);
  if (overlay) overlay.addEventListener('click', closeMobileMenu);

  document.addEventListener('keydown', (e) => {
    if (
      e.key === 'Escape' &&
      drawer &&
      drawer.classList.contains('header__mobile-drawer--open')
    ) {
      closeMobileMenu();
    }
  });

  // Prestige-style collapsible accordion
  if (drawer) {
    drawer.addEventListener('click', (event) => {
      const toggle = event.target.closest('[data-collapsible-toggle]');
      if (!toggle || !drawer.contains(toggle)) return;

      const inner = toggle.nextElementSibling;
      if (!inner || !inner.classList.contains('header__mobile-collapsible-inner')) return;

      const isExpanded = toggle.getAttribute('aria-expanded') === 'true';

      if (isExpanded) {
        inner.style.height = `${inner.scrollHeight}px`;
        requestAnimationFrame(() => {
          inner.style.height = '0px';
        });
        toggle.setAttribute('aria-expanded', 'false');
      } else {
        toggle.setAttribute('aria-expanded', 'true');
        inner.style.height = `${inner.scrollHeight}px`;

        const onEnd = (e) => {
          if (e.propertyName !== 'height') return;
          if (toggle.getAttribute('aria-expanded') === 'true') {
            inner.style.height = 'auto';
          }
          inner.removeEventListener('transitionend', onEnd);
        };
        inner.addEventListener('transitionend', onEnd);
      }
    });
  }
});
